import { put, takeLatest, call } from 'redux-saga/effects';
import * as BrandsActions from './action';
import { fetchCuisines } from '../../../api';
import type { Effect } from 'redux-saga/effects';

export function* handleFetchBrands(): Generator<Effect, void, any> {
  try {
    const brands = yield call(fetchCuisines);
    yield put(BrandsActions.fetchBrandsSuccess(brands));
  } catch (err) {
    const error = err as any;
    yield put(BrandsActions.fetchBrandsFail(error?.message || 'Error fetching brands'));
  }
}

export function* watchFetchBrands() {
  yield takeLatest(BrandsActions.FETCH_BRANDS, handleFetchBrands);
}
